import { RequestDataProvider, RequestSender, useRequestSender } from 'request-sender';
import { useTokenContext } from '../Authentication';
import { useApiConfiguration } from './ApiConfigurationContext';
import { useTimezoneService } from './timezoneService';

export interface BackendApiProps {
  version?: number
}

export function useBackendApi(props?: BackendApiProps): RequestSender {
  const tokenContext = useTokenContext();

  const apiConfiguration = useApiConfiguration();

  const timezoneService = useTimezoneService();

  const dataProviders: RequestDataProvider[] = [
    {
      getHeaders: () => tokenContext.getApiHeaders(),
    },
    {
      getHeaders: () => ({
        'X-NEKST-TIMEZONE': timezoneService.getTimezone(),
      })
    }
  ];

  return useRequestSender({
    baseUrl: apiConfiguration.backendUrl,
    dataProviders,
    version: props?.version,
  });
}
